import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const THEME_OPTION = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;

export type ThemeOption = (typeof THEME_OPTION)[keyof typeof THEME_OPTION];

interface ThemeState {
  theme: ThemeOption;
  changeTheme: (theme: ThemeOption) => void;
}

const useThemeStore = create<ThemeState>()(
  devtools(
    persist(
      (set) => ({
        theme: 'light',
        changeTheme: (theme) =>
          set(() => ({
            theme,
          })),
      }),
      { name: 'THEME_KEY' },
    ),
  ),
);

export default useThemeStore;
